import { BorderedContainer } from '../../../common/BorderedContainer';
import { SectionTitle } from '../../../common/SectionTitle';
import { InfoDisplay } from '../../common/InfoDisplay';
import { IncidentDetailPatient } from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';

type Props = {
  /** 備考。 */
  note: IncidentDetailPatient['note'];
};

/** 備考のコンポーネント。 */
export const Note = ({ note }: Props) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="備考" />
        <InfoDisplay title="備考" content={note ?? ''} />
      </div>
    </BorderedContainer>
  );
};
